import Loadable from 'react-loadable';
import LoadingPage from '../../../../fetching/LoadingPage';

export const LazyLoadedUserTermsPageEn = Loadable<any, any>({
  loader: async () =>
    import(/* webpackChunkName: "sb1-user-terms-en" */ './LocalizedSb1UserTermsPage').then(
      (module) => module.LocalizedSb1UserTermsPageEn
    ),
  loading: LoadingPage,
});
